import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import { Logs as LogsIcon, Notebook as NotebookIcon } from 'common/icons'
import {
  getContentHasVariants,
  getElementHasVariants,
  getIsOptimized,
} from 'features/unifiedFlow/contentPage/helpers'
import {
  useContent,
  useSelectedElement,
} from 'features/unifiedFlow/contentPage/hooks'

import ExportMenuButton from '../../components/layout/components/ExportMenuButton'

import { HandleActivePanelChange } from './RightSection'

type Props = {
  showInputResultsButton: boolean
  onInputResultsClick: () => void
  handleActivePanelChange: HandleActivePanelChange
}

const CollapsedIcons = ({
  showInputResultsButton,
  onInputResultsClick,
  handleActivePanelChange,
}: Props) => {
  const { content } = useContent()
  const { data: selectedElement } = useSelectedElement()

  const isOptimized = getIsOptimized(selectedElement)
  const hasVariants = getContentHasVariants(content)
  const hasElementVariants = getElementHasVariants(selectedElement)

  return (
    <>
      {isOptimized && hasElementVariants && (
        <ButtonWithTooltip
          data-testid="logs-sidebar-button"
          variant="icon"
          tooltip
          tooltipText="Logs"
          placement="left"
          prefixIcon={
            <LogsIcon
              size={6}
              isDefaultColor={false}
              className="text-gold-600 cursor-pointer hover:text-gold-700"
            />
          }
          onClick={() => handleActivePanelChange('logs')}
        />
      )}
      {showInputResultsButton && isOptimized && hasElementVariants && (
        <ButtonWithTooltip
          data-testid="input-results-button"
          variant="icon"
          tooltip
          tooltipText="Input Results"
          placement="left"
          prefixIcon={
            <NotebookIcon
              size={6}
              isDefaultColor={false}
              className="text-gold-600 cursor-pointer hover:text-gold-700"
            />
          }
          onClick={onInputResultsClick}
        />
      )}
      {selectedElement && hasVariants && (
        <div className="flex items-stretch" style={{ height: '24px' }}>
          <ExportMenuButton tooltipPlacement="left" />
        </div>
      )}
    </>
  )
}

export default CollapsedIcons
